import {action, observable, reaction} from "mobx";
import {getByAtribute} from "../../../utils/formatar";
import _ from "lodash";

export default class ValidacaoStore {
    @observable isValidForm;
    @observable campos;
    @observable desabilitarValidacao;
    constructor() {
        this.mensagensErro = {
            isEmail: "Informe um e-mail válido",
            areEmails: "Informe e-mails válidos separados por vírgula",
            isRequired: "Este campo é obrigatório",
            isArrayNotEmpty: "Este campo é obrigatório",
            isBooleanRequired: "Confirme esta opção",
            isRequiredMonthYearDate: "Este campo é obrigatório",
            maxLength: "Tamanho máximo de caracteres é de ",
            isCPF: "Informe um CPF válido",
            isArrayUnique: "Valores informados duplicados",
            isCNPJ: "Informe um número de CNPJ válido",
            quantidadeMin: "Valor informado abaixo do limite permitido",
            quantidadeMax: "Valor informado acima do limite permitido",
            salarioMin: "Valor informado abaixo do limite permitido",
            salarioMax: "Valor informado acima do limite permitido",
            isDate: "Informe uma data válida",
            solicContratacaoDiasMin: "Valor informado abaixo do limite permitido",
            solicContratacaoDiasMax: "Valor informado acima do limite permitido",
            SolicDiasMin: "Data anterior ao limite permitido",
            SolicDiasMax: "Data posterior ao limite permitido",
            endDateAfter: "Data de término inferior ou igual à data de início",
            endDateSame: "Para desligamento na mesma data de inicio, entre em contato com o RH.",
            endDateSameOrAfter: "Data de término inferior à data de início",
            endDateMax1Month: "O período da pesquisa deve ter no máximo 1 mês",
            endDateMax3Month: "O período da pesquisa deve ter no máximo 3 meses",
            endDateMax12Months: "O período da pesquisa deve ter no máximo 12 meses",
            empregadosSubstituidosMin: "Número de empregados informados abaixo do limite permitido",
            empregadosSubstituidosMax: "Número de empregados informados acima do limite permitido",
            mesmoCPF: "Informe um CPF diferente",
            compararDataAnterior: "Data anterior ao permitido",
            compararDataPosterior: "Data posterior ao permitido",
            empregadosMesmoCargo: "Todos os empregados substituídos devem possuir o mesmo cargo",
            mesmaJustificativa: "Obrigatório alterar a justificativa da prorrogação",
            isIdadeValida: "A idade mínima é de 16 anos.",
            compararDatasRestritas: "A data informada não pode ser utilizada.",
            justificativaCusteioDireto: "Justificativa somente para áreas com controle de Planejamento/Alocação.",
            salarioBaseCargoInvalido: "Não foi possível encontrar a grade salarial do cargo para a lotação selecionada."
        };
        this.isValidForm = true;
        this.campos = [];
        this.desabilitarValidacao = false;
    }

    isValid = (campos) => {
        if(!campos) {
            return this.isValidForm;
        } else {
            let invalidos = this.campos.filter(function (el) {
                if(_.includes(campos, el.field)) {
                    return el.valid === false;
                } else {
                    return false;
                }
            });
            return !(invalidos && invalidos.length > 0);
        }
    };


    resetDados(id) {
        this.campoValid(id, true);
        this.submitStatus()
    }

    @action campoValid(campo, status) {
        const fieldExistente = _.find(this.campos,{field: campo});
        if(fieldExistente) {
            fieldExistente.valid = status;
        } else {
            this.campos.push({ field: campo, valid: status});
        }
    }

    @action submitStatus() {
        let required = this.campos.filter(function (el) {
            return el.valid === false;
        });

        this.isValidForm = !(required && required.length > 0);
    }

    getMensagemErro(tipo, mensagem) {
        if(Array.isArray(tipo)){
            return mensagem && mensagem[tipo[0]] ? mensagem[tipo[0]] + tipo[1] :  this.mensagensErro[tipo[0]] + tipo[1];
        }else {
            return mensagem && mensagem[tipo] ? mensagem[tipo] : this.mensagensErro[tipo];
        }
    }

    isNumber = (n) =>{
        return !isNaN(parseFloat(n)) && isFinite(n);
    };

    isURL = (x) => {
        const regex = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
        return regex.test(x);
    };

    isEmail = (email) => {
        if(email) {
            const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regex.test(email);
        } else {
            return true;
        }
    };

    areEmails = (emails) => {
        if(emails) {
            return emails
                .replace(/ /g, '')
                .split(',')
                .map(this.isEmail)
                .every(email => email);
        } else {
            return true;
        }
    };

    isArrayUnique = (array) => {
        const set = new Set(array);
        return set.size === array.length;
    };

    isCPF = (cpf) => {
        if(!cpf)
            return true

        cpf = cpf.replace(/[^\d]+/g,'');
        if(cpf == '') return false;
        if (cpf.length != 11 ||
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999")
            return false;
        var add = 0;
        for (var i=0; i < 9; i ++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
        var rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(9)))
            return false;
        add = 0;
        for (i = 0; i < 10; i ++)
            add += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(10)))
            return false;
        return true;
    }

    isDate = (s) => {
        if(!s)
            return true
        if(s.length!=10)
            return false

        // format D(D)/M(M)/(YY)YY
        var dateFormat = /^\d{1,4}[\.|\/|-]\d{1,2}[\.|\/|-]\d{1,4}$/;

        if (dateFormat.test(s)) {
            // remove any leading zeros from date values
            s = s.replace(/0*(\d*)/gi,"$1");
            var dateArray = s.split(/[\.|\/|-]/);

            // correct month value
            dateArray[1] = dateArray[1]-1;

            // correct year value
            if (dateArray[2].length<4) {
                // correct year value
                dateArray[2] = (parseInt(dateArray[2]) < 50) ? 2000 + parseInt(dateArray[2]) : 1900 + parseInt(dateArray[2]);
            }

            var testDate = new Date(dateArray[2], dateArray[1], dateArray[0]);
            if (testDate.getDate()!=dateArray[0] || testDate.getMonth()!=dateArray[1] || testDate.getFullYear()!=dateArray[2]) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
}
